<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="form" inline>
					<c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button @click="exportData()">导出</c-button>
			</m-operate>
			
			<c-table ref="table">				

				<c-table-column
					label="日期"
					name="statistic_date"
				>
				</c-table-column>
				
				<c-table-column
					label="订单数"
					name="order_count"
				>
				</c-table-column>
				
				<c-table-column
					label="销量"
					name="sales_quantity"
				>
				</c-table-column>
				
				<c-table-column
					label="交易总额"
					name="sales_amount"
				>
					<template v-slot="{data}">
						￥{{data.sales_amount}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="支付人数"
					name="pay_user_quantity"
				>
				</c-table-column>
				
				<c-table-column
					label="取消单数"
					name="cancel_order_count"
				>
				</c-table-column>

				<c-table-column
					label="取消数量"
					name="cancel_quantity"
				>
				</c-table-column>

				<c-table-column
					label="取消总额"
					name="cancel_amount"
				>
					<template v-slot="{data}">
						￥{{data.cancel_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="退款数量"
					name="refund_quantity"
				>
				</c-table-column>

				<c-table-column
					label="退款总额"
					name="refund_amount"
				>
					<template v-slot="{data}">
						￥{{data.refund_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="退货数量"
					name="return_quantity"
				>
				</c-table-column>

				<c-table-column
					label="退货总额"
					name="return_amount"
				>
					<template v-slot="{data}">
						￥{{data.return_amount}}
					</template>
				</c-table-column>

			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/statistic/trans/list',
					data
				});
			},
			exportData(){
				var exportData = this.$refs.form.serialize();
				exportData.job_id = 32;
				exportData.create_system = 'OMS';
				
				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>